export enum PayoutErrorType {
    TICKET_NOT_FOUND = 'TICKET_NOT_FOUND',
    WIN_AMOUNT_TOO_LARGE = 'WIN_AMOUNT_TOO_LARGE',
    INVALID_CARD_NUMBER = 'INVALID_CARD_NUMBER',
    INVALID_CONTROL_CODE = 'INVALID_CONTROL_CODE',
    ALREADY_PAID_OUT = 'ALREADY_PAID_OUT'
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/terminal/app/modals/_private/enums.ts